/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { KeyValuePair } from './keyValuePair';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { VcdsDisconnectedDeploymentCommerceHistory } from './vcdsDisconnectedDeploymentCommerceHistory';
import { VcdsDisconnectedDeploymentStateEnum } from './vcdsDisconnectedDeploymentStateEnum';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';
import { CommerceModeEnum } from './commerceModeEnum';


export interface VcdsDisconnectedDeploymentRaw { 
    commerce_mode?: CommerceModeEnum;
    /**
     * Component Id
     */
    component_id?: string;
    /**
     * Component Version
     */
    component_version?: string;
    /**
     * Created by user
     */
    created_by?: string;
    /**
     * Deployment creation date time
     */
    created_ts?: Date;
    /**
     * encrypted hash value of deactivation code
     */
    deactivation_code?: string;
    /**
     * Deleted by user
     */
    deleted_by?: string;
    /**
     * Deployment deletion date time
     */
    deleted_ts?: Date;
    /**
     * Deployment Id
     */
    deployment_id?: string;
    /**
     * Expiry date
     */
    expiry_date?: Date;
    /**
     * Resource FQDN
     */
    fqdn?: string;
    history?: Array<VcdsDisconnectedDeploymentCommerceHistory>;
    metadata?: Array<KeyValuePair>;
    /**
     * Component name
     */
    name?: string;
    /**
     * Org Id
     */
    org_id?: string;
    /**
     * Peer Deployment Id
     */
    peer_deployment_id?: string;
    quantity?: number;
    sequence_number?: number;
    service_type?: ServiceTypeEnum;
    state?: VcdsDisconnectedDeploymentStateEnum;
    /**
     * Updated by user
     */
    update_by?: string;
    /**
     * Deployment last updated date time
     */
    updated_ts?: Date;
    vcds_service_type?: VcdsServiceTypeEnum;
    /**
     * Provider ID in format: <res-type>-<res-id>
     */
    vcenter_id?: string;
}
export namespace VcdsDisconnectedDeploymentRaw {
}


